import React, { useState } from 'react'
import { View, Text, ScrollView, StyleProp, ViewStyle } from 'react-native'
import {
  BG_STYLES,
  BORDER_STYLES,
  BottomDrawer,
  COMMON_STYLES,
  DropdownContainer,
  RadioButton,
  Spinner,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { SCREEN_HEIGHT } from 'app/utils/common'

interface Props {
  loading?: boolean
  placeholder?: string
  value: string
  onChange: (key: string) => void
  options: Record<string, string>[]
  labelKey?: string
  valueKey?: string
  containerStyle?: StyleProp<ViewStyle>
  isDisabled?: boolean
  error?: boolean
  errorText?: string
  modalStyle?: StyleProp<ViewStyle>
}

const DropdownInput = ({
  loading,
  value,
  onChange,
  options,
  placeholder = 'Select',
  labelKey = 'value',
  valueKey = 'id',
  containerStyle,
  isDisabled = false,
  error,
  errorText,
  modalStyle,
}: Props) => {
  const [isDirty, setIsDirty] = useState(false)
  const [showOptions, setShowOptions] = useState(false)
  const selectedOptionIndex = options?.findIndex(
    option => option[valueKey] === value,
  )

  return (
    <View>
      <DropdownContainer
        placeholder={options?.[selectedOptionIndex]?.[labelKey] || placeholder}
        onClick={() => {
          if (!isDisabled) {
            setShowOptions(true)
          }
        }}
        containerStyle={[
          BORDER_STYLES.borderNeutral20,
          containerStyle,
          isDirty && error && BORDER_STYLES.borderError100,
        ]}
      />
      {isDirty && error && errorText && (
        <Text
          style={[
            TYPOGRAPHY.CAPTION1,
            VARIANTS_STYLES.BASE,
            TEXT_STYLES.textError100,
          ]}
        >
          {errorText}
        </Text>
      )}
      <BottomDrawer
        heading={placeholder}
        onClose={() => {
          setShowOptions(false)
          if (!value) setIsDirty(true)
        }}
        visible={showOptions}
        modalStyle={modalStyle}
      >
        <View style={{ maxHeight: SCREEN_HEIGHT * 0.6 }}>
          {loading ? (
            <Spinner />
          ) : (
            <ScrollView>
              <RadioButton
                list={options.map(option => ({
                  radioElement: (
                    <Text
                      style={[
                        TYPOGRAPHY.HEADING3,
                        VARIANTS_STYLES.BASE,
                        TEXT_STYLES.textNeutral70,
                      ]}
                    >
                      {option[labelKey]}
                    </Text>
                  ),
                  value: option[valueKey],
                }))}
                onClick={index => {
                  onChange(options[index][valueKey])
                  setShowOptions(false)
                }}
                selected={selectedOptionIndex}
                containerStyle={[
                  { gap: 8 },
                  COMMON_STYLES['p1/2'],
                  BORDER_STYLES.borderNeutral00,
                  COMMON_STYLES.b1,
                  COMMON_STYLES['br1/2'],
                ]}
                selectedRadioContainerStyle={[
                  BG_STYLES.bgPrimary10,
                  BORDER_STYLES.borderPrimary100,
                ]}
              />
            </ScrollView>
          )}
        </View>
      </BottomDrawer>
    </View>
  )
}

export default DropdownInput
